import { Product } from "~data/Product";

import { Confetti } from "../../providers/ConfettiProvider";
import ProductLogo from "../brand/ProductLogo";
import Link from "../ui/Link";

type Props = {
  children: React.ReactNode;
  successMessage?: string;
  product?: Product;
};

function Gradient() {
  return (
    <img
      src={new URL("img/gradient.png", import.meta.url).href}
      className="absolute left-0 top-0 w-full select-none dark:hidden"
      draggable="false"
    />
  );
}

export default function AuthLayout({ children, product }: Props) {
  return (
    <>
      <Confetti />
      <div className="flex h-screen w-full flex-row bg-white dark:bg-gray-900">
        <div className="flex h-full flex-1 flex-col overflow-y-auto bg-gray-50 dark:bg-gray-900">
          <div className="mx-auto flex size-full max-w-[440px] flex-col items-start justify-between space-y-10 px-4 py-8">
            <Link to={["up.auth.login", { product }]}>
              <ProductLogo product={product} className="relative z-10 text-black dark:text-white" />
            </Link>
            <div className="relative z-10 flex w-full flex-col space-y-6">{children}</div>
            <div />
          </div>
          <Gradient />
        </div>
      </div>
    </>
  );
}
